module.exports = "<block>\n    <v-button slot=\"center\" status=\"warning\">Confirm</v-button>\n    <v-button slot=\"center\" style=\"margin-left:10px;\">Cancel</v-button>\n</block>\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/example/3-center.html
// module id = 208
// module chunks = 1